export default "__VITE_ASSET__BwNKJJTC__"